import React from 'react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PhoneField.css';

/**
 * PhoneField — standard international phone input.
 *
 * One field with a searchable country/flag selector, live as-you-type
 * formatting, and a single E.164 value (e.g. "+971561759994"). The country
 * is inferred from the value, so there is no separate country-code state to
 * keep in sync. Empty input emits '' (callers store '' / null).
 *
 * Replaces the previous hand-rolled "country-code dropdown + local number +
 * parseE164Phone split/recombine" scheme, which mis-parsed numbers whose
 * country code differed from the dropdown default and could exceed the 20-char
 * backend limit by re-prepending a code on every save.
 */
const PhoneField = ({
  id,
  label,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  defaultCountry = 'ZA',
  placeholder = 'Enter phone number',
}) => (
  <div className="phone-field">
    {label && (
      <label htmlFor={id}>
        {label}
        {required && <span className="phone-field-required"> *</span>}
      </label>
    )}
    <PhoneInput
      id={id}
      international
      countryCallingCodeEditable={false}
      defaultCountry={defaultCountry}
      value={value || undefined}
      onChange={(v) => onChange(v || '')}
      disabled={disabled}
      placeholder={placeholder}
      className={`phone-field-input${error ? ' phone-field-input--error' : ''}`}
    />
    {error && <div className="phone-field-error">{error}</div>}
  </div>
);

export { isValidPhoneNumber };
export default PhoneField;
